import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRightSm = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 12,
	viewBox: "0 0 20 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	className: "ml-1 md:ml-2 w-4 h-4 md:w-5 md:h-5 transition-transform transform group-hover:translate-x-1",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M18.6807 8L0 8",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0933 1.41406L18.6807 8.00148L12.0933 14.5889",
			stroke: "currentColor",
			strokeWidth: 1.5
		})
	]
});
const ForwardRef = forwardRef(SvgArrowRightSm);
export { ForwardRef as ReactComponent };
